import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import {
  actionSettingAdd,
  actionSettingCompanyAdd,
  createAuthMoloni,
  deleteCompanySetting,
  getByNameProduct,
  getCommonSearchList,
  getCompanyList,
  getCompanyPlanChange,
  getSettingsCompanyDetails,
  getSettingsDetails,
} from "../../services/settingsServices";
import ConfigDB from "../../config";
import { getViewAllParkList } from "../../services/ParkServices";
import moment from "moment";
import { getSubscriptionList } from "../../services/AuthServices";
import Pagination from "react-js-pagination";
import { useTranslation } from "react-i18next";
import { SketchPicker } from "react-color";
import { getRoleList } from "../../services/UserServices";

const Settings = () => {
  const { t } = useTranslation();

  const [settingData, setSettingData] = useState({
    uuid: "",
    team_size: "",
    about_description: "",
    contact_description: "",
    address: "",
    email: "",
    experience: "",
    mobile: "",
    facebook_url: "",
    instagram_url: "",
    youtube_url: "",
    whatsapp_url: "",
    linkedin_url: "",
    google_play_url: "",
    app_store_url: "",
    footer_description: "",
    our_services_description: "",
    part_image_limit: "",
    cron_job_ping_time: "",
    provider_code: "",
    secret: "",
    salt: "",
    part_video_size: "",
    part_video_limit: "",
  });

  const [settingCompanyData, setSettingCompanyData] = useState({
    id: "",
    is_force_cron_job: 0,
    state_id: "",
    condition_id: "",
    discount_percentage: "",
    print_label: 0,
    park_id: "",
    part_column_ids: "",
    vat_included: 0,
    reg_number_dismantler: "",
    is_enable_ecommerce_access: 0,
    default_color: "",
    default_image: "",
    printer_api: "",
    paper_size: "",
    printer_name: "",
    is_free_search: 0,
    open_search_tab: "",
    sort_field: "",
    sort_type: "",
    task_sort_field: "",
    task_sort_type: "",
    sales_vat_price: "23",
    template_title: "",
    template_text: "",
    print_ping_time: "",
    reference_type: "",
    reference_condition: "",
    associate_location: 1,
    part_share_column_ids: "",
    vehicle_share_column_ids: "",
    timezone_id: "",
    edit_photo_type: "",
    attribute_id: "",
    role_id: "",
    is_view: "",
    is_edit: "",
    invoice_platform_id: "",
    is_all_sync: 0,
    moloni_price_id: "",
    is_green_part: 0,
    inventory_status_filter: 0,
    vehicle_status_filter: 0,
    no_of_parts_per_page: 10,
    no_of_vehicles_per_page: 10,
    allow_add_existing_parts_vehicle: 0,
    part_display_column_ids: "",
    vehicle_display_column_ids: "",
    moloni_price: "",
    total_value_packaging: "",
    total_value_other_parcel: "",
    total_value_shipping: "",
    exemption_vat_products: "",
    exemption_vat_shipping: "",
    exemption_vat_packaging: "",
    exemption_reason: "",
    price_stats: "",
    is_hide_expiry_date_popup: 0,
    cost_price_based_on: "",
  });

  const tableLengthList = ConfigDB.data.dataTableLength;

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });

  const state = useLocation();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [image, setImage] = useState(null);
  const [previewUrlAbout, setPreviewUrlAbout] = useState(null);
  const [AboutImage, setAboutImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalAbout, setShowModalAbout] = useState(false);
  const [settingDetails, setSettingDetails] = useState("");
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");

  const [inputFields, setInputFields] = useState([
    { id: "", id_sirapa: "", vat_number: "" },
  ]);

  const [selectedRadio, setSelectedRadio] = useState("1");
  const [stateList, setStateList] = useState([]);

  const [conditionList, setConditionList] = useState([]);
  const [parkList, setParkList] = useState([]);
  const [partColumnList, setPartColumnList] = useState([]);
  const [inputValueLer, setInputValueLer] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [companystatus, setCompanystatus] = useState(false);
  const [companystatusData, setCompanystatusData] = useState("");
  const [SubscriptionList, setSubscriptionList] = useState([]);
  const [CompanyPlanData, SetCompanyPlanData] = useState({
    subscription_id: "",
    subscription_expiry: "",
    is_subscribed: "",
    plan_id: "",
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [imageDefualt, setImageDefualt] = useState(null);
  const [previewUrlDefualt, setPreviewUrlDefualt] = useState(null);
  const [color, setColor] = useState("#ffffff");
  const [filterSerachList, setFilterSerachList] = useState([]);
  const [openSerachList, setOpenSerachList] = useState([]);
  const [sortList, setSortList] = useState([]);
  const [sortTypeList, setSortTypeList] = useState([]);
  const [taskSortList, setTaskSortList] = useState([]);
  const [tasksortTypeList, setTasksortTypeList] = useState([]);
  const [referenceList, setReferenceList] = useState([]);
  const [partShareColumnList, setPartShareColumnList] = useState([]);
  const [vehicleShareColumnList, setVehicleShareColumnList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [editPhotoTypeList, setEditPhotoTypeList] = useState([]);
  const [attributeList, setAttributeList] = useState([]);
  const [roleList, setRolelList] = useState([]);
  const [settingCompanyDataList, setSettingCompanyDataList] = useState([
    {
      attribute_id: "",
      is_view: 0,
      is_edit: 0,
      role_id: "",
    },
  ]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [loadingMoloni, setLoadingMoloni] = useState(false);
  const [PageLengthList, setPageLengthList] = useState([]);
  const [partInventoryList, setPartInventoryList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);
  const [priceStatesList, setPriceStatesList] = useState([]);
  const [packagingModel, setPackagingModel] = useState(false);
  const [otherParcelModel, setOtherParcelModel] = useState(false);
  const [shippingModel, setShippingModel] = useState(false);
  const [packingList, setPackingList] = useState([]);
  const [packingSerach, setPackingSerach] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [parcelList, setParcelList] = useState([]);
  const [parcelSerach, setParcelSerach] = useState("");
  const [selectedParcelId, setSelectedParcelId] = useState(null);
  const [shippingList, setShippingList] = useState([]);
  const [shippingSerach, setShippingSerach] = useState("");
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [delOtherModal, setDelOtherModal] = useState(false);
  const [delPackingModal, setDelPackingModal] = useState(false);
  const [delShippingModal, setDelShippingModal] = useState(false);

  const onDeleteModalOtherClose = () => {
    setDelOtherModal(false);
  };
  const onDeleteModalPackingClose = () => {
    setDelPackingModal(false);
  };
  const onDeleteModalShipplingClose = () => {
    setDelShippingModal(false);
  };

  const handleAddRow = () => {
    const isValid = settingCompanyDataList.every(
      (row) => row.attribute_id !== "",
    );

    if (!isValid) {
      toast.error(t("toast_fill_attribute_ids"));
      return;
    }
    const newRow = {
      attribute_id: "",
      is_view: 0,
      is_edit: 0,
      role_id: "",
    };
    setSettingCompanyDataList((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (index) => {
    const updatedList = [...settingCompanyDataList];
    updatedList.splice(index, 1);
    setSettingCompanyDataList(updatedList);
  };

  const handleAttributeChange = (selectedOptions, index) => {
    const updatedList = [...settingCompanyDataList];
    updatedList[index].attribute_id = selectedOptions
      ? selectedOptions.map((opt) => opt.value).join(",")
      : "";
    setSettingCompanyDataList(updatedList);
  };

  const handleRoleChange = (selectedOption, index) => {
    const updatedList = [...settingCompanyDataList];
    updatedList[index].role_id = selectedOption ? selectedOption.value : "";
    setSettingCompanyDataList(updatedList);
  };

  const handleCheckboxAttributeChange = (index, key) => {
    const updatedList = [...settingCompanyDataList];
    updatedList[index][key] = updatedList[index][key] === 1 ? 0 : 1;
    setSettingCompanyDataList(updatedList);
  };
  const handleChangeColor = (newColor) => {
    if (newColor && newColor.hex) {
      setColor(newColor.hex);
    }
  };

  const handleFileChangeDefualt = (event) => {
    const selectedFiles = event.target.files[0];

    if (selectedFiles) {
      setImageDefualt(selectedFiles);
      const imageUrl = URL.createObjectURL(selectedFiles);
      setPreviewUrlDefualt(imageUrl);
    }
  };

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e;
    }
    setParams(paramsObj);
  };

  const formatDate = (isoString) => {
    return isoString ? new Date(isoString).toISOString().split("T")[0] : "";
  };

  const handleCheckboxChangeProfile = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      is_enable_ecommerce_access: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxAssociateLocation = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      associate_location: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxSync = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      is_all_sync: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxIsGreenPartSync = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      is_green_part: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxAllowExistingPartsVehicle = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      allow_add_existing_parts_vehicle: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxIsHideExpiryDatePopup = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      is_hide_expiry_date_popup: e.target.checked ? 1 : 0,
    });
  };

  useEffect(() => {
    if (companystatusData) {
      SetCompanyPlanData({
        subscription_id: companystatusData?.subscription_id,
        subscription_expiry: companystatusData?.subscription_expiry,
        is_subscribed: companystatusData?.is_subscribed,
      });
    }
  }, [companystatusData]);

  const handleCloseCompany = () => {
    setCompanystatus(false);
  };

  const handleCheckboxChangeIsSubscribe = (e) => {
    SetCompanyPlanData({
      ...CompanyPlanData,
      is_subscribed: e.target.checked ? 1 : 0,
    });
  };

  useEffect(() => {
    getSubscriptionList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setSubscriptionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (packingSerach) {
      let data = {
        name: packingSerach,
      };
      getByNameProduct(data)
        .then((response) => {
          setPackingList(response.data.product);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [packingSerach]);

  const handlePackingOpen = () => {
    setPackagingModel(true);
  };

  const handlePackingClose = () => {
    setPackagingModel(false);
  };

  useEffect(() => {
    if (shippingSerach) {
      let data = {
        name: shippingSerach,
      };
      getByNameProduct(data)
        .then((response) => {
          setShippingList(response.data.product);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [shippingSerach]);

  const handleShippingOpen = () => {
    setShippingModel(true);
  };

  const handleShippingClose = () => {
    setShippingModel(false);
  };

  useEffect(() => {
    if (parcelSerach) {
      let data = {
        name: parcelSerach,
      };
      getByNameProduct(data)
        .then((response) => {
          setParcelList(response.data.product);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [parcelSerach]);

  const handleParcelOpen = () => {
    setOtherParcelModel(true);
  };

  const handleParcelClose = () => {
    setOtherParcelModel(false);
  };

  const handleOpenCompany = (e, item) => {
    setCompanystatusData(item);
    setCompanystatus(true);
  };

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  const data = localStorage.getItem(ConfigDB.data.login_data);
  const isAdmin = JSON.parse(data);

  const handleAddInput = () => {
    setInputFields([...inputFields, { id_sirapa: "", vat_number: "" }]);
  };

  const handleRemoveInput = (index) => {
    const credentialId = inputFields[index]?.id;

    const newInputFields = inputFields.filter((_, i) => i !== index);

    setInputFields(newInputFields);

    if (credentialId) {
      const data = {
        id: credentialId,
      };

      deleteCompanySetting(data)
        .then((response) => {
          toast.dismiss();
          toast.success(response.data.message);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  useEffect(() => {
    getRoleList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setRolelList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "filter_search_column",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setFilterSerachList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "filter_tab",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setOpenSerachList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "sort_field",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setSortList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "sort_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setSortTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_sort_field",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskSortList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "price_states",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPriceStatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_sort_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTasksortTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "timezone_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimezoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "edit_photo_type_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setEditPhotoTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_inventory_attribute_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setAttributeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (stateList.length > 0 && !settingCompanyData.state_id) {
      setSettingCompanyData((prev) => ({
        ...prev,
        state_id: stateList[0].value,
      }));
    }
  }, [stateList]);

  useEffect(() => {
    if (conditionList.length > 0) {
      setSettingCompanyData((prev) => ({
        ...prev,
        condition_id: conditionList[0].value,
        reference_condition: conditionList[0].value,
      }));
    }
  }, [conditionList]);

  useEffect(() => {
    if (parkList.length > 0 && !settingCompanyData.park_id) {
      setSettingCompanyData((prev) => ({
        ...prev,
        park_id: parkList[0].value,
      }));
    }
  }, [parkList]);

  useEffect(() => {
    if (openSerachList.length > 0 && !settingCompanyData.open_search_tab) {
      setSettingCompanyData((prev) => ({
        ...prev,
        open_search_tab: openSerachList[0].value,
      }));
    }
  }, [openSerachList]);

  useEffect(() => {
    if (sortList.length > 0 && !settingCompanyData.sort_field) {
      setSettingCompanyData((prev) => ({
        ...prev,
        sort_field: sortList[0].value,
      }));
    }
  }, [sortList]);

  useEffect(() => {
    if (sortTypeList.length > 0 && !settingCompanyData.sort_type) {
      setSettingCompanyData((prev) => ({
        ...prev,
        sort_type: sortTypeList[0].value,
      }));
    }
  }, [sortTypeList]);

  useEffect(() => {
    if (taskSortList.length > 0 && !settingCompanyData.task_sort_field) {
      setSettingCompanyData((prev) => ({
        ...prev,
        task_sort_field: taskSortList[0].value,
      }));
    }
  }, [taskSortList]);

  useEffect(() => {
    if (tasksortTypeList?.length > 0 && !settingCompanyData?.task_sort_type) {
      setSettingCompanyData((prev) => ({
        ...prev,
        task_sort_type: tasksortTypeList[0]?.value,
      }));
    }
  }, [tasksortTypeList]);

  useEffect(() => {
    const data = {
      limit: 20,
      page: 1,
      search: "",
      type: "invoice_list_platform",
    };

    getCommonSearchList(data)
      .then((response) => {
        const platforms = response.data.data || [];

        const list = platforms.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setInvoiceList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const data = {
      limit: 20,
      page: 1,
      search: "",
      type: "price_list",
    };

    getCommonSearchList(data)
      .then((response) => {
        const platforms = response.data.data || [];

        const list = platforms.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setPriceList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInvoiceChange = (selectedOption) => {
    const selectedId = selectedOption.value;

    setSettingCompanyData((prev) => ({
      ...prev,
      invoice_platform_id: selectedId,
    }));
  };

  let popupInterval = null;

  const handlePlatFormSubmit = async () => {
    try {
      const data = {
        platform_id: settingCompanyData?.invoice_platform_id,
      };

      const response = await createAuthMoloni(data);
      const url = response?.data?.data;
      setLoadingMoloni(true);
      const popupWindow = window.open(
        url,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes",
      );

      const popupInterval = setInterval(async () => {
        if (popupWindow && popupWindow.closed) {
          clearInterval(popupInterval);
          try {
            const companyResponse = await getSettingsCompanyDetails();
            setSettingCompanyDetails(companyResponse.data.data);
            setLoadingMoloni(false);
          } catch (err) {
            setLoadingMoloni(false);
            console.error("Failed to fetch updated company details:", err);
          }
        }
      }, 2000);
    } catch (err) {
      console.error("API error:", err);
    }
  };

  useEffect(() => {
    return () => {
      if (popupInterval) {
        clearInterval(popupInterval);
      }
    };
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "reference",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setReferenceList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "state",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStateList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "condition",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setConditionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    var obj = {
      search: "",
      limit: 10,
      page: 1,
    };
    getViewAllParkList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].place,
          });
        }
        setParkList(list);
      })
      .catch((err) => {});
  }, []);

  const handleChange = (index, event) => {
    const newInputFields = [...inputFields];
    const { name, value } = event.target;

    if (name?.startsWith("id_sirapa")) {
      newInputFields[index].id_sirapa = value;
    } else if (name?.startsWith("vat_number")) {
      newInputFields[index].vat_number = value;
    }

    setInputFields(newInputFields);
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleShowAbout = () => setShowModalAbout(true);
  const handleCloseAbout = () => setShowModalAbout(false);

  useEffect(() => {
    if (settingDetails) {
      setSettingData({
        team_size: settingDetails?.team_size,
        about_description: settingDetails?.about_description,
        contact_description: settingDetails?.contact_description,
        address: settingDetails?.address,
        email: settingDetails?.email,
        mobile: settingDetails?.mobile,
        facebook_url: settingDetails?.facebook_url,
        instagram_url: settingDetails?.instagram_url,
        youtube_url: settingDetails?.youtube_url,
        whatsapp_url: settingDetails?.whatsapp_url,
        linkedin_url: settingDetails?.linkedin_url,
        google_play_url: settingDetails?.google_play_url,
        app_store_url: settingDetails?.app_store_url,
        footer_description: settingDetails?.footer_description,
        experience: settingDetails?.experience,
        our_services_description: settingDetails?.our_services_description,
        part_image_limit: settingDetails?.part_image_limit,
        cron_job_ping_time: settingDetails?.cron_job_ping_time,
        provider_code: settingDetails?.provider_code,
        secret: settingDetails?.secret,
        salt: settingDetails?.salt,
        part_video_limit: settingDetails?.part_video_limit,
        part_video_size: settingDetails?.part_video_size,

        is_force_cron_job: settingDetails?.is_force_cron_job,
      });
      setPreviewUrl(settingDetails?.header_image);
      setPreviewUrlAbout(settingDetails?.about_image);
      setImage(settingDetails?.header_image);
      setAboutImage(settingDetails?.about_image);
    }
  }, [settingDetails]);

  useEffect(() => {
    if (settingCompanyDetails) {
      setSettingCompanyData({
        ...settingCompanyDetails,

        is_force_cron_job: settingCompanyDetails?.is_force_cron_job,
        label_machine: settingCompanyDetails?.label_machine,
        state_id: settingCompanyDetails?.state_id,
        condition_id: settingCompanyDetails?.condition_id,
        discount_percentage: settingCompanyDetails?.discount_percentage,
        print_label: settingCompanyDetails?.print_label,
        park_id: settingCompanyDetails?.park_id,
        part_column_ids: settingCompanyDetails?.part_column_ids,
        vat_included: settingCompanyDetails?.vat_included,
        reg_number_dismantler: settingCompanyDetails?.reg_number_dismantler,
        is_enable_ecommerce_access:
          settingCompanyDetails?.is_enable_ecommerce_access,
        printer_api: settingCompanyDetails?.printer_api,
        paper_size: settingCompanyDetails?.paper_size,
        printer_name: settingCompanyDetails?.printer_name,
        is_free_search: settingCompanyDetails?.is_free_search,
        open_search_tab: settingCompanyDetails?.open_search_tab,
        sort_field: settingCompanyDetails?.sort_field,
        sort_type: settingCompanyDetails?.sort_type,
        task_sort_field: settingCompanyDetails?.task_sort_field,
        task_sort_type: settingCompanyDetails?.task_sort_type,
        sales_vat_price: settingCompanyDetails?.sales_vat_price,
        template_title: settingCompanyDetails?.template_title,
        template_text: settingCompanyDetails?.template_text,
        print_ping_time: settingCompanyDetails?.print_ping_time,
        reference_condition: settingCompanyDetails?.reference_condition
          ? settingCompanyDetails?.reference_condition
          : 0,
        reference_type: settingCompanyDetails?.reference_type
          ? settingCompanyDetails?.reference_type
          : 2,
        associate_location: settingCompanyDetails?.associate_location
          ? settingCompanyDetails?.associate_location
          : 1,
        is_all_sync: settingCompanyDetails?.is_all_sync
          ? settingCompanyDetails?.is_all_sync
          : 0,
        is_green_part: settingCompanyDetails?.is_green_part
          ? settingCompanyDetails?.is_green_part
          : 0,
        part_share_column_ids: settingCompanyDetails?.part_share_column_ids,
        vehicle_share_column_ids:
          settingCompanyDetails?.vehicle_share_column_ids,
        timezone_id: settingCompanyDetails?.timezone_id,
        attribute_id:
          settingCompanyDetails?.part_inventory_attribute?.attribute_id,
        role_id: Number(
          settingCompanyDetails?.part_inventory_attribute?.role_id,
        ),
        is_view: settingCompanyDetails?.part_inventory_attribute?.is_view,

        is_edit: settingCompanyDetails?.part_inventory_attribute?.is_edit,
        invoice_platform_id: settingCompanyDetails?.invoice_platform_id,
        moloni_price_id: settingCompanyDetails?.moloni_price_id,
        inventory_status_filter: settingCompanyDetails?.inventory_status_filter,
        vehicle_status_filter: settingCompanyDetails?.vehicle_status_filter,
        no_of_parts_per_page: settingCompanyDetails?.no_of_parts_per_page || 10,
        no_of_vehicles_per_page:
          settingCompanyDetails?.no_of_vehicles_per_page || 10,
        allow_add_existing_parts_vehicle:
          settingCompanyDetails?.allow_add_existing_parts_vehicle
            ? settingCompanyDetails?.allow_add_existing_parts_vehicle
            : 0,
        part_display_column_ids:
          settingCompanyDetails?.part_display_columns?.columnsIds,
        vehicle_display_column_ids:
          settingCompanyDetails?.vehicle_display_columns?.columnsIds,
        total_value_packaging: settingCompanyDetails?.total_value_packaging,
        total_value_other_parcel:
          settingCompanyDetails?.total_value_other_parcel,
        total_value_shipping: settingCompanyDetails?.total_value_shipping,
        exemption_vat_products: settingCompanyDetails?.exemption_vat_products,
        exemption_vat_shipping: settingCompanyDetails?.exemption_vat_shipping,
        exemption_vat_packaging: settingCompanyDetails?.exemption_vat_packaging,
        exemption_reason: settingCompanyDetails?.exemption_reason,
        price_stats: settingCompanyDetails?.price_stats,
        is_hide_expiry_date_popup:
          settingCompanyDetails?.is_hide_expiry_date_popup
            ? settingCompanyDetails?.is_hide_expiry_date_popup
            : 0,
        cost_price_based_on: settingCompanyDetails?.cost_price_based_on,
      });
      setInputFields(settingCompanyDetails?.credential);
      setSelectedRadio(String(settingCompanyDetails?.label_machine));
      // setColor(settingCompanyDetails?.default_color);
      setImageDefualt(settingCompanyDetails?.default_image);
      setPreviewUrlDefualt(settingCompanyDetails?.default_image);
      setSelectedId(settingCompanyDetails?.packaging_id);
      setSelectedParcelId(settingCompanyDetails?.other_parcel_id);
      setSelectedShippingId(settingCompanyDetails?.shipping_id);

      const formatted = settingCompanyDetails?.page_length?.map((num) => ({
        value: num,
        label: String(num),
      }));

      setPageLengthList(formatted);

      if (
        !Array.isArray(settingCompanyDetails?.part_inventory_attribute) ||
        settingCompanyDetails.part_inventory_attribute.length === 0
      ) {
        setSettingCompanyDataList([
          {
            attribute_id: "",
            is_view: 0,
            is_edit: 0,
            role_id: "",
          },
        ]);
      } else {
        setSettingCompanyDataList(
          settingCompanyDetails.part_inventory_attribute,
        );
      }
    }
  }, [settingCompanyDetails]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        if (isAdmin.role_id === "1") {
          const settingsResponse = await getSettingsDetails();
          setSettingDetails(settingsResponse.data.data);
        }

        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files[0];

    if (selectedFiles) {
      setImage(selectedFiles);
      const imageUrl = URL.createObjectURL(selectedFiles);
      setPreviewUrl(imageUrl);
    }
  };

  const handleAboutFileChange = (event) => {
    const selectedFiles = event.target.files[0];

    if (selectedFiles) {
      setAboutImage(selectedFiles);
      const imageUrl = URL.createObjectURL(selectedFiles);
      setPreviewUrlAbout(imageUrl);
    }
  };

  const handleSettingForm = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("header_image", image);
    formData.append("about_description", settingData?.about_description);
    formData.append("about_image", AboutImage);
    formData.append("experience", settingData?.experience);
    formData.append("team_size", settingData?.team_size);
    formData.append("contact_description", settingData?.contact_description);
    formData.append("address", settingData?.address);
    formData.append("email", settingData?.email);
    formData.append("mobile", settingData?.mobile);
    formData.append("facebook_url", settingData?.facebook_url);
    formData.append("instagram_url", settingData?.instagram_url);
    formData.append("youtube_url", settingData?.youtube_url);
    formData.append("whatsapp_url", settingData?.whatsapp_url);
    formData.append("linkedin_url", settingData?.linkedin_url);
    formData.append("google_play_url", settingData?.google_play_url);
    formData.append("app_store_url", settingData?.app_store_url);
    formData.append("footer_description", settingData?.footer_description);
    formData.append(
      "our_services_description",
      settingData?.our_services_description,
    );
    formData.append("part_image_limit", settingData?.part_image_limit);
    formData.append("cron_job_ping_time", settingData?.cron_job_ping_time);
    formData.append("provider_code", settingData?.provider_code);
    formData.append("secret", settingData?.secret);
    formData.append("salt", settingData?.salt);
    formData.append("part_video_limit", settingData?.part_video_limit);
    formData.append("part_video_size", settingData?.part_video_size);

    actionSettingAdd(formData)
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSettingCompanyForm = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("is_force_cron_job", settingCompanyData?.is_force_cron_job);
    formData.append("credential", JSON.stringify(inputFields));
    formData.append("label_machine", selectedRadio);
    formData.append("state_id", settingCompanyData?.state_id);
    formData.append("condition_id", settingCompanyData?.condition_id);
    formData.append(
      "discount_percentage",
      settingCompanyData?.discount_percentage,
    );
    formData.append("print_label", settingCompanyData?.print_label);
    formData.append("park_id", settingCompanyData?.park_id);
    formData.append("part_column_ids", settingCompanyData?.part_column_ids);
    formData.append("vat_included", settingCompanyData?.vat_included);
    formData.append(
      "reg_number_dismantler",
      settingCompanyData?.reg_number_dismantler,
    );
    formData.append(
      "is_enable_ecommerce_access",
      settingCompanyData?.is_enable_ecommerce_access || 0,
    );
    formData.append(
      "reg_number_dismantler",
      settingCompanyData?.reg_number_dismantler,
    );
    // formData.append("default_color", color);
    formData.append("default_image", imageDefualt);
    formData.append("printer_name", settingCompanyData?.printer_name);
    formData.append("paper_size", settingCompanyData?.paper_size);
    formData.append("printer_api", settingCompanyData?.printer_api);
    formData.append("is_free_search", settingCompanyData?.is_free_search);
    formData.append("open_search_tab", settingCompanyData?.open_search_tab);
    formData.append("sort_field", settingCompanyData?.sort_field);
    formData.append("sort_type", settingCompanyData?.sort_type);
    formData.append("task_sort_field", settingCompanyData?.task_sort_field);
    formData.append("task_sort_type", settingCompanyData?.task_sort_type);
    formData.append("sales_vat_price", settingCompanyData?.sales_vat_price);
    formData.append("template_title", settingCompanyData?.template_title);
    formData.append("template_text", settingCompanyData?.template_text);
    formData.append("print_ping_time", settingCompanyData?.print_ping_time);
    formData.append("reference_type", settingCompanyData?.reference_type);
    formData.append(
      "reference_condition",
      settingCompanyData?.reference_condition,
    );
    formData.append(
      "associate_location",
      settingCompanyData?.associate_location,
    );
    formData.append(
      "part_share_column_ids",
      settingCompanyData?.part_share_column_ids,
    );
    formData.append(
      "part_display_column_ids",
      settingCompanyData?.part_display_column_ids,
    );

    formData.append(
      "vehicle_display_column_ids",
      settingCompanyData?.vehicle_display_column_ids,
    );

    formData.append(
      "vehicle_share_column_ids",
      settingCompanyData?.vehicle_share_column_ids,
    );
    formData.append("timezone_id", settingCompanyData?.timezone_id);
    formData.append("edit_photo_type", settingCompanyData?.edit_photo_type);
    const formattedAttributeList = settingCompanyDataList.map((item) => ({
      attribute_id: item.attribute_id,
      role_id: item.role_id,
      is_view: item.is_view,
      is_edit: item.is_edit,
      id: item.id || "",
    }));

    const filteredAttributes = formattedAttributeList.filter(
      (attr) =>
        attr.attribute_id ||
        attr.role_id ||
        attr.id ||
        attr.is_view ||
        attr.is_edit,
    );

    formData.append("part_attribute_list", JSON.stringify(filteredAttributes));
    formData.append(
      "invoice_platform_id",
      settingCompanyData?.invoice_platform_id,
    );
    formData.append("is_all_sync", settingCompanyData?.is_all_sync);
    formData.append("moloni_price_id", settingCompanyData?.moloni_price_id);
    formData.append("packaging_id", selectedId?.id);
    formData.append("other_parcel_id", selectedParcelId?.id);
    formData.append("shipping_id", selectedShippingId?.id);
    formData.append(
      "exemption_vat_products",
      settingCompanyData?.exemption_vat_products,
    );
    formData.append(
      "exemption_vat_shipping",
      settingCompanyData?.exemption_vat_shipping,
    );
    formData.append(
      "exemption_vat_packaging",
      settingCompanyData?.exemption_vat_packaging,
    );
    formData.append("exemption_reason", settingCompanyData?.exemption_reason);

    formData.append("is_green_part", Number(settingCompanyData?.is_green_part));
    formData.append(
      "inventory_status_filter",
      settingCompanyData?.inventory_status_filter,
    );
    formData.append(
      "vehicle_status_filter",
      settingCompanyData?.vehicle_status_filter,
    );
    formData.append(
      "no_of_parts_per_page",
      settingCompanyData?.no_of_parts_per_page,
    );
    formData.append(
      "no_of_vehicles_per_page",
      settingCompanyData?.no_of_vehicles_per_page,
    );
    formData.append(
      "allow_add_existing_parts_vehicle",
      settingCompanyData?.allow_add_existing_parts_vehicle,
    );

    formData.append("price_stats", settingCompanyData?.price_stats);
    formData.append(
      "is_hide_expiry_date_popup",
      settingCompanyData?.is_hide_expiry_date_popup,
    );
    formData.append(
      "cost_price_based_on",
      settingCompanyData?.cost_price_based_on,
    );

    actionSettingCompanyAdd(formData)
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleChangePlanSubmit = (e) => {
    e.preventDefault();

    const data = {
      subscription_id: CompanyPlanData?.subscription_id,
      subscription_expiry: CompanyPlanData?.subscription_expiry,
      is_subscribed: CompanyPlanData?.is_subscribed,
      company_id: companystatusData?.id,
    };
    getCompanyPlanChange(data)
      .then((response) => {
        toast.success(response.data.message);
        setCompanystatus(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleCheckboxChange = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      is_force_cron_job: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangePrint = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      print_label: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeVat = (e) => {
    setSettingCompanyData({
      ...settingCompanyData,
      vat_included: e.target.checked ? 1 : 0,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_column",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartColumnList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_inventory_columns",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartInventoryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_display_columns",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setVehicleList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_share_column",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartShareColumnList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_share_column",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setVehicleShareColumnList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      let data = {
        ...params,
      };
      getCompanyList(data)
        .then((response) => {
          setCompanyList(response.data.data);
          setTotalRecords(response?.data?.total);
        })
        .catch((err) => {});
    },
    [params],
  );

  const handleSelectLERChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value).join(",")
      : "";

    setSettingCompanyData({
      ...settingCompanyData,
      part_column_ids: selectedValues,
    });
  };

  const handleSelectPartShareChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value).join(",")
      : "";

    setSettingCompanyData({
      ...settingCompanyData,
      part_share_column_ids: selectedValues,
    });
  };

  const handleSelectPartInventoryChange = (selected) => {
    setSettingCompanyData((prev) => {
      const prevIds = (prev.part_display_column_ids || "").split(",");

      const newIds = selected.map((item) => String(item.value));

      const finalOrder = newIds.filter((id) => newIds.includes(id));

      return {
        ...prev,
        part_display_column_ids: finalOrder.join(","),
      };
    });
  };

  const handleSelectVehicleDisplayChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSettingCompanyData({
        ...settingCompanyData,
        vehicle_display_column_ids: "",
      });
      return;
    }

    const newOrder = selectedOptions.map((opt) => String(opt.value));

    setSettingCompanyData({
      ...settingCompanyData,
      vehicle_display_column_ids: newOrder.join(","),
    });
  };

  const handleSelectVehicleShareChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value).join(",")
      : "";

    setSettingCompanyData({
      ...settingCompanyData,
      vehicle_share_column_ids: selectedValues,
    });
  };

  const handleSelectPlanChange = (selectedOption) => {
    if (!selectedOption) {
      SetCompanyPlanData({
        ...CompanyPlanData,
        subscription_id: "",
        subscription_expiry: "",
      });
      return;
    }

    const currentDate = new Date();

    currentDate.setMonth(currentDate.getMonth() + 1);

    const formattedDate = currentDate.toISOString().split("T")[0];

    SetCompanyPlanData({
      ...CompanyPlanData,
      subscription_id: selectedOption.value,
      subscription_expiry: formattedDate,
    });
  };

  return (
    <div>
      {loadingMoloni && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 bottom-0 start-0 end-0 z-3"
          style={{ zIndex: "99", backgroundColor: "#ffffffc2" }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Settings</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right"></ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary">
                {isAdmin?.role_id === "1" ? (
                  <>
                    <Form method={`post`} onSubmit={handleSettingForm}>
                      <div className="card-body">
                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <h3>Header</h3>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Header Image"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <div className="avatar-upload">
                                    <div className="avatar-edit">
                                      <div className="input-div">
                                        <input
                                          className="inputFile"
                                          type="file"
                                          id="imageUpload"
                                          onChange={handleFileChange}
                                          name="file"
                                          accept=".jpg,.jpeg,.png"
                                        />
                                        {previewUrl && (
                                          <i
                                            className="bi bi-eye eyeIcon"
                                            onClick={handleShow}
                                          ></i>
                                        )}
                                      </div>
                                      <label htmlFor="imageUpload"></label>
                                    </div>
                                    {/* <div className="avatar-preview profile-user">
                                  {previewUrl && (
                                    <i
                                      className="bi bi-eye"
                                      onClick={handleShow}
                                    ></i>
                                  )}
                                </div> */}
                                  </div>
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Part Image Limit"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={settingData?.part_image_limit}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        part_image_limit: e.target.value,
                                      });
                                    }}
                                    name={`part_image_limit`}
                                    placeholder={t("part_image_limit")}
                                  />
                                </div>{" "}
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <h3>About</h3>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"About Description"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.about_description}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        about_description: e.target.value,
                                      });
                                    }}
                                    name={`about_description`}
                                    placeholder={t("about_description")}
                                    rows={4}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"About Image"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <div className="avatar-upload">
                                    <div className="avatar-edit">
                                      <div className="input-div">
                                        <input
                                          className="inputFile"
                                          type="file"
                                          id="imageuploadAbout"
                                          onChange={handleAboutFileChange}
                                          name="file"
                                          accept=".jpg,.jpeg,.png"
                                        />
                                        {previewUrlAbout && (
                                          <i
                                            style={{
                                              position: "absolute",
                                              top: "6px",
                                              right: "12px",
                                              fontSize: "20px",
                                              color: "#81bb42",
                                            }}
                                            className="bi bi-eye"
                                            onClick={handleShowAbout}
                                          ></i>
                                        )}
                                      </div>

                                      <label htmlFor="imageuploadAbout"></label>
                                    </div>
                                    {/* <div className="avatar-preview profile-user">
                                  <img
                                    src={previewUrlAbout}
                                    style={{
                                      width: "500px",
                                      height: "225px",
                                      bordeRadius: "75px",
                                      marginLeft: "15px",
                                      marginBottom: "20px",
                                    }}
                                  />
                                </div> */}
                                  </div>
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Experience"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.experience}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        experience: e.target.value,
                                      });
                                    }}
                                    name={`experience`}
                                    placeholder={t("experience")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Team Size"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.team_size}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        team_size: e.target.value,
                                      });
                                    }}
                                    name={`team_size`}
                                    placeholder={t("team_size")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <h3>Contact</h3>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Contact Description"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.contact_description}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        contact_description: e.target.value,
                                      });
                                    }}
                                    name={`contact_description`}
                                    placeholder={t("contact_description")}
                                    rows={4}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("e_mail")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.email}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        email: e.target.value,
                                      });
                                    }}
                                    name={`email`}
                                    placeholder={t("email")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Facebook URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.facebook_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        facebook_url: e.target.value,
                                      });
                                    }}
                                    name={`facebook_url`}
                                    placeholder={t("facebook_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Youtube URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.youtube_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        youtube_url: e.target.value,
                                      });
                                    }}
                                    name={`youtube_url`}
                                    placeholder={t("youtube_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Linkedin URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.linkedin_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        linkedin_url: e.target.value,
                                      });
                                    }}
                                    name={`linkedin_url`}
                                    placeholder={t("linkedin_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"App Store URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.app_store_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        app_store_url: e.target.value,
                                      });
                                    }}
                                    name={`app_store_url`}
                                    placeholder={t("app_store_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Address"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.address}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        address: e.target.value,
                                      });
                                    }}
                                    name={`address`}
                                    placeholder={t("address")}
                                    rows={4}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Mobile"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.mobile}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        mobile: e.target.value,
                                      });
                                    }}
                                    name={`mobile`}
                                    maxLength={10}
                                    placeholder={t("mobile")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Instagram URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.instagram_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        instagram_url: e.target.value,
                                      });
                                    }}
                                    name={`instagram_url`}
                                    placeholder={t("instagram_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Whatsapp URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.whatsapp_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        whatsapp_url: e.target.value,
                                      });
                                    }}
                                    name={`whatsapp_url`}
                                    placeholder={t("whatsapp_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Google play URL"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.google_play_url}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        google_play_url: e.target.value,
                                      });
                                    }}
                                    name={`google_play_url`}
                                    placeholder={t("google_play_url")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <h3>Footer</h3>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Footer Description"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.footer_description}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        footer_description: e.target.value,
                                      });
                                    }}
                                    name={`footer_description`}
                                    placeholder={t("footer_description")}
                                    rows={4}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Our Services Description"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={settingData.our_services_description}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        our_services_description:
                                          e.target.value,
                                      });
                                    }}
                                    name={`our_services_description`}
                                    placeholder={t("our_services_description")}
                                    rows={4}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <div className="row">
                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Minute"}
                                </Label>
                                <div className="col-md-3">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search form-control"
                                      type="text"
                                      value={settingData.cron_job_ping_time}
                                      onChange={(e) => {
                                        setSettingData({
                                          ...settingData,
                                          cron_job_ping_time: e.target.value,
                                        });
                                      }}
                                      name={`cron_job_ping_time`}
                                      maxLength={9}
                                      placeholder="minute"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Provider Code"}
                                </Label>
                                <div className="col-xl-6">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search form-control"
                                      type="text"
                                      value={settingData.provider_code}
                                      onChange={(e) => {
                                        setSettingData({
                                          ...settingData,
                                          provider_code: e.target.value,
                                        });
                                      }}
                                      name={`provider_code`}
                                      placeholder={t("provider_code")}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Secret"}
                                </Label>
                                <div className="col-xl-6">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search form-control"
                                      type="text"
                                      value={settingData.secret}
                                      onChange={(e) => {
                                        setSettingData({
                                          ...settingData,
                                          secret: e.target.value,
                                        });
                                      }}
                                      name={`secret`}
                                      placeholder="secret"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Salt"}
                                </Label>
                                <div className="col-xl-6">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search form-control"
                                      type="text"
                                      value={settingData.salt}
                                      onChange={(e) => {
                                        setSettingData({
                                          ...settingData,
                                          salt: e.target.value,
                                        });
                                      }}
                                      name={`salt`}
                                      maxLength={9}
                                      placeholder={t("salt")}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>
                          </div>

                          <div className="col-md-12 ms-2">
                            <Button
                              type="button"
                              onClick={handleAddInput}
                              color="primary"
                            >
                              <i className="bi bi-plus-lg"></i>
                            </Button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label">
                                {"Part Video Size(MB)"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div d-flex">
                                  <input
                                    className="form-control"
                                    type="number"
                                    min="0"
                                    step="0.1"
                                    value={settingData.part_video_size}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        part_video_size: e.target.value,
                                      });
                                    }}
                                    name={`part_video_size `}
                                    placeholder={t("part_video_size")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label">
                                {"Part video limit"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div d-flex">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={settingData.part_video_limit}
                                    onChange={(e) => {
                                      setSettingData({
                                        ...settingData,
                                        part_video_limit: e.target.value,
                                      });
                                    }}
                                    name={`part_video_limit `}
                                    placeholder={t("part_video_limit")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="col-form-label ml-2 Label-my form-label form-label">
                          <h3>Company List</h3>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="col-md-6"
                              style={{ marginBottom: "10px" }}
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={params.search}
                                onChange={(e) => handleParams(e, "search")}
                                placeholder={t("search_by_company_name_email")}
                              ></input>
                            </div>
                            <div className="vehicleparts-table-inner vehicleThBg tableScroll table-scroll-modal">
                              <table className="rounded-table table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th style={{ width: "10%" }}>
                                      Company Name
                                    </th>
                                    <th style={{ width: "10%" }}>Email </th>
                                    <th style={{ width: "10%" }}>
                                      Created Date
                                    </th>
                                    <th style={{ width: "10%" }}>Plan Name</th>

                                    <th style={{ width: "10%" }}>
                                      Expriry Date
                                    </th>
                                    <th style={{ width: "10%" }}>Subscribed</th>
                                    <th style={{ width: "0%" }}>
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {companyList?.length > 0 ? (
                                    companyList?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.name}</td>
                                        <td>{item.email}</td>
                                        <td>
                                          {moment(item.created_at).format(
                                            "DD/MM/YYYY",
                                          )}
                                        </td>

                                        <td>{item.subscription_name}</td>
                                        <td>
                                          {moment(
                                            item.subscription_expiry,
                                          ).format("DD/MM/YYYY")}
                                        </td>
                                        <td
                                          style={{
                                            color:
                                              item.is_subscribed === 1
                                                ? "green"
                                                : "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {item.is_subscribed
                                            ? "Subscribed"
                                            : "Not Subscribed"}
                                        </td>

                                        <td>
                                          <button
                                            className="login-btn"
                                            type="button"
                                            onClick={(e) =>
                                              handleOpenCompany(e, item)
                                            }
                                            style={{ width: "103px" }}
                                          >
                                            Change Plan
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="100%">No results found</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <div className="fuelCF">
                              <div
                                className="card-footer card-footer-part clearfix"
                                style={{ marginTop: "-250px" }}
                              >
                                <div className="pagination pagination-sm m-0 float-right">
                                  <Pagination
                                    activePage={params.page}
                                    itemsCountPerPage={parseInt(params.limit)}
                                    totalItemsCount={parseInt(totalRecords)}
                                    pageRangeDisplayed={5}
                                    itemClass={`page-item`}
                                    linkClass={`page-link`}
                                    onChange={(e) =>
                                      handleParams(e, "pagination")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col"></div>
                        <div className="col">
                          <div
                            className="d-flex justify-content-end"
                            style={{ padding: "10px" }}
                          >
                            <button type="submit" className="btn btn-primary">{t("submit")}<i className="bi bi-check2"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer"></div>
                    </Form>
                  </>
                ) : (
                  <Form method={`post`} onSubmit={handleSettingCompanyForm}>
                    {isAdmin?.default_user === 1 ? (
                      <>
                        <div className="card-body">
                          <div className="col-form-label ml-2 Label-my form-label form-label">
                            <h3>Credentials</h3>
                            <span
                              style={{
                                background: "#a11212",
                                color: "#fff",
                                padding: "6px",
                              }}
                            >
                              {" "}
                              <strong>Note:</strong> read the vehicles
                              certificates
                            </span>
                          </div>
                          <div className="row justify-content-start">
                            {inputFields?.map((inputField, index) => (
                              <>
                                <div className="col-md-6" key={index}>
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label">
                                      {"id Sirapa"}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div d-flex">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={inputField.id_sirapa}
                                          onChange={(e) =>
                                            handleChange(index, e)
                                          }
                                          name={`id_sirapa_${index}`}
                                          placeholder="id Sirapa"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-6" key={index}>
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label">
                                      {"Vat Number"}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div d-flex input-sett-custom">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={inputField.vat_number}
                                          onChange={(e) =>
                                            handleChange(index, e)
                                          }
                                          name={`vat_number_${index}`}
                                          placeholder={t("vat_number")}
                                        />
                                        <Button
                                          type="button"
                                          onClick={() =>
                                            handleRemoveInput(index)
                                          }
                                          color="danger"
                                          className="setting-btn"
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </Button>
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                              </>
                            ))}

                            <div className="col-md-12 ms-2">
                              <Button
                                type="button"
                                onClick={handleAddInput}
                                color="primary"
                              >
                                <i className="bi bi-plus-lg"></i>
                              </Button>
                            </div>
                            <div className="row justify-content-start">
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Is Force Cron Job
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData.is_force_cron_job ===
                                            1
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                        <label className="form-check-label pl-6">
                                          Is Force Cron Job
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Label Machine"}
                                  </Label>
                                  <div style={{ display: "flex" }}>
                                    <div className="form-check form-check-radio">
                                      <input
                                        className="form-check-input custom-radio"
                                        type="radio"
                                        name="flexRadio"
                                        id="flexRadio1"
                                        value="1"
                                        checked={selectedRadio === "1"}
                                        onChange={handleRadioChange}
                                      />
                                      <label
                                        className="form-check-label form-label form-label"
                                        htmlFor="flexRadio1"
                                      >
                                        Zebra Label
                                      </label>
                                    </div>

                                    <div
                                      className="form-check form-check-radio"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <input
                                        className="form-check-input custom-radio"
                                        type="radio"
                                        name="flexRadio"
                                        id="flexRadio2"
                                        value="2"
                                        checked={selectedRadio === "2"}
                                        onChange={handleRadioChange}
                                      />
                                      <label
                                        className="form-check-label form-label form-label"
                                        htmlFor="flexRadio2"
                                      >
                                        Brothers Label
                                      </label>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-6"></div>
                            </div>

                            <div className="row justify-content-start">
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select State"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div ">
                                      <Select
                                        options={stateList}
                                        value={stateList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.state_id,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            state_id: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select State"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Condition"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={conditionList}
                                        value={conditionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.condition_id,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            condition_id: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Condition"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Park"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={parkList}
                                        value={parkList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.park_id,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            park_id: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Park"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Filter serach"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={filterSerachList}
                                        value={filterSerachList.find(
                                          (option) =>
                                            option.value ===
                                            Number(
                                              settingCompanyData.is_free_search,
                                            ),
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            is_free_search:
                                              selectedOption?.value ?? 0,
                                          })
                                        }
                                        placeholder={"Select Filter Serach"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Open serach tab"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={openSerachList}
                                        value={openSerachList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.open_search_tab,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            open_search_tab:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Open serach tab"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Sort field"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={sortList}
                                        value={sortList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.sort_field,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            sort_field: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Sort field"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Sort type"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={sortTypeList}
                                        value={sortTypeList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.sort_type,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            sort_type: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Sort type"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Task Sort field"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={taskSortList}
                                        value={taskSortList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.task_sort_field,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            task_sort_field:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Task Sort field"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Task Sort type"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={tasksortTypeList}
                                        value={tasksortTypeList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.task_sort_type,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            task_sort_type:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Task Sort type"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Sales VAT Price"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={
                                          settingCompanyData.sales_vat_price
                                        }
                                        onChange={(e) => {
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            sales_vat_price: e.target.value,
                                          });
                                        }}
                                        name={`sales_vat_price`}
                                        placeholder={t("sales_vat_price")}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {t("template_title")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={
                                          settingCompanyData.template_title
                                        }
                                        onChange={(e) => {
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            template_title: e.target.value,
                                          });
                                        }}
                                        name={`template_title`}
                                        placeholder={t("template_title")}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {t("template_text")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={settingCompanyData.template_text}
                                        onChange={(e) => {
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            template_text: e.target.value,
                                          });
                                        }}
                                        name={`template_text`}
                                        placeholder={t("template_text")}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Type Reference"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={referenceList}
                                        value={referenceList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.reference_type,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            reference_type:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Task Sort type"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Reference Condition"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={conditionList}
                                        value={conditionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.reference_condition,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            reference_condition:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={
                                          "Select Reference Condition"
                                        }
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("select_timezone")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={timezoneList}
                                        value={timezoneList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.timezone_id,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            timezone_id: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Timezone"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("select_edit_photo_type")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={editPhotoTypeList}
                                        value={editPhotoTypeList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.edit_photo_type,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            edit_photo_type:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Edit photo type"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Sort field"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={sortList}
                                        value={sortList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.sort_field,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            sort_field: selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Sort field"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("associate_location")}{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData?.associate_location ===
                                            1
                                          }
                                          onChange={
                                            handleCheckboxAssociateLocation
                                          }
                                        />
                                        <label className="form-check-label pl-6">
                                          {t("associate_location")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Part Column"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={partColumnList}
                                        value={partColumnList.filter((option) =>
                                          (
                                            settingCompanyData.part_column_ids ||
                                            ""
                                          )
                                            .split(",")
                                            .includes(String(option.value)),
                                        )}
                                        onChange={handleSelectLERChange}
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti
                                        placeholder={"Select Part"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Vehicle Share Column"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={vehicleShareColumnList}
                                        value={vehicleShareColumnList.filter(
                                          (option) =>
                                            (
                                              settingCompanyData.vehicle_share_column_ids ||
                                              ""
                                            )
                                              .split(",")
                                              .includes(String(option.value)),
                                        )}
                                        onChange={
                                          handleSelectVehicleShareChange
                                        }
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti
                                        placeholder={
                                          "Select Vehicle Share Column"
                                        }
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Part Share Column"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={partShareColumnList}
                                        value={partShareColumnList.filter(
                                          (option) =>
                                            (
                                              settingCompanyData.part_share_column_ids ||
                                              ""
                                            )
                                              .split(",")
                                              .includes(String(option.value)),
                                        )}
                                        onChange={handleSelectPartShareChange}
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti
                                        placeholder={"Select Part Share Column"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Part Inventory Columns"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={partInventoryList}
                                        value={(
                                          settingCompanyData.part_display_column_ids ||
                                          ""
                                        )
                                          .split(",")
                                          .map((id) =>
                                            partInventoryList.find(
                                              (option) =>
                                                String(option.value) === id,
                                            ),
                                          )
                                          .filter(Boolean)}
                                        onChange={
                                          handleSelectPartInventoryChange
                                        }
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti
                                        placeholder={
                                          "Select Part Inventory Columns"
                                        }
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Select Vehicle Columns"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={vehicleList}
                                        value={(
                                          settingCompanyData.vehicle_display_column_ids ||
                                          ""
                                        )
                                          .split(",")
                                          .map((id) =>
                                            vehicleList.find(
                                              (option) =>
                                                String(option.value) === id,
                                            ),
                                          )
                                          .filter(Boolean)}
                                        onChange={
                                          handleSelectVehicleDisplayChange
                                        }
                                        isSearchable={true}
                                        isClearable={true}
                                        isMulti
                                        placeholder={"Select Vehicle Columns"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row justify-content-start">
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("parts_per_page")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={PageLengthList}
                                        value={PageLengthList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.no_of_parts_per_page,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            no_of_parts_per_page:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Parts Per Page"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("vehicles_per_page")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={PageLengthList}
                                        value={PageLengthList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.no_of_vehicles_per_page,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            no_of_vehicles_per_page:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Vehicles Per Page"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("inventory_status")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={
                                          ConfigDB?.data
                                            ?.inventoryStatusFilterList
                                        }
                                        value={ConfigDB?.data?.inventoryStatusFilterList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.inventory_status_filter,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            inventory_status_filter:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Inventory Status"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("vehicle_status")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={
                                          ConfigDB?.data
                                            ?.vehicleStatusFilterList
                                        }
                                        value={ConfigDB?.data?.vehicleStatusFilterList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.vehicle_status_filter,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            vehicle_status_filter:
                                              selectedOption.value,
                                          })
                                        }
                                        placeholder={"Select Vehicle Status"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Discount Percentage(%)"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div d-flex">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={
                                          settingCompanyData.discount_percentage
                                        }
                                        onChange={(e) => {
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            discount_percentage: e.target.value,
                                          });
                                        }}
                                        name={`discount_percentage`}
                                        maxLength={3}
                                        placeholder={t("discount_percentage")}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Register Number dismetal"}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div d-flex">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={
                                          settingCompanyData.reg_number_dismantler
                                        }
                                        onChange={(e) => {
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            reg_number_dismantler:
                                              e.target.value,
                                          });
                                        }}
                                        name={`reg_number_dismantler`}
                                        placeholder={t("register_number_dismantle")}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("price_stats")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={priceStatesList}
                                        value={
                                          priceStatesList.find(
                                            (option) =>
                                              option.value ===
                                              settingCompanyData.price_stats,
                                          ) || null
                                        }
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            price_stats: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          })
                                        }
                                        placeholder={"Select Price States"}
                                        isSearchable
                                        isClearable
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("cost_price_based_on")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={
                                          ConfigDB?.data?.costPriceBasedOnList
                                        }
                                        value={
                                          ConfigDB?.data?.costPriceBasedOnList.find(
                                            (option) =>
                                              option.value ===
                                              settingCompanyData.cost_price_based_on,
                                          ) || null
                                        }
                                        onChange={(selectedOption) =>
                                          setSettingCompanyData({
                                            ...settingCompanyData,
                                            cost_price_based_on: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          })
                                        }
                                        placeholder={
                                          "Select Cost Price Based On"
                                        }
                                        isSearchable
                                        isClearable
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Print Label{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData.print_label === 1
                                          }
                                          onChange={handleCheckboxChangePrint}
                                        />
                                        <label className="form-check-label pl-6">
                                          Print Label
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    VAT included{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData.vat_included ===
                                            1
                                          }
                                          onChange={handleCheckboxChangeVat}
                                        />
                                        <label className="form-check-label pl-6">
                                          VAT included{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              {/* Descontinuado: o intervalo de impressão
                                  automática passou a ser configurado na app
                                  desktop TP Software (Settings → Sincronização
                                  Automática) para permitir valores diferentes
                                  por bancada / operador. */}

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Is enable ecommerce access{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData?.is_enable_ecommerce_access ===
                                            1
                                          }
                                          onChange={handleCheckboxChangeProfile}
                                        />
                                        <label className="form-check-label pl-6">
                                          E-commerce Products{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("is_green_part")}{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData?.is_green_part ===
                                            1
                                          }
                                          onChange={
                                            handleCheckboxIsGreenPartSync
                                          }
                                        />
                                        <label className="form-check-label pl-6">
                                          {t("is_green_part")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    htmlFor="allow_add_existing_parts_vehicle"
                                  >
                                    {t("allow_add_existing_parts_vehicle")}{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData?.allow_add_existing_parts_vehicle ===
                                            1
                                          }
                                          onChange={
                                            handleCheckboxAllowExistingPartsVehicle
                                          }
                                          id="allow_add_existing_parts_vehicle"
                                        />
                                        <label
                                          className="form-check-label pl-6"
                                          htmlFor="allow_add_existing_parts_vehicle"
                                        >
                                          {t(
                                            "allow_add_existing_parts_vehicle",
                                          )}{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    htmlFor="is_hide_expiry_date_popup"
                                  >
                                    {t("is_hide_expiry_date_popup")}{" "}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            settingCompanyData?.is_hide_expiry_date_popup ===
                                            1
                                          }
                                          onChange={
                                            handleCheckboxIsHideExpiryDatePopup
                                          }
                                          id="is_hide_expiry_date_popup"
                                        />
                                        <label
                                          className="form-check-label pl-6"
                                          htmlFor="is_hide_expiry_date_popup"
                                        >
                                          {t("is_hide_expiry_date_popup")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <div>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Color Picker{" "}
                                  </Label>
                                  <SketchPicker
                                    color={color}
                                    onChange={handleChangeColor}
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Image"}
                                </Label>
                                <div className="avatar-upload">
                                  <div className="avatar-edit">
                                    <div className="input-div">
                                      <input
                                        className="inputFile"
                                        type="file"
                                        id="imageUploads"
                                        onChange={handleFileChangeDefualt}
                                        name="file"
                                        accept=".jpg,.jpeg,.png"
                                      />
                                    </div>
                                    <label htmlFor="imageUploads"></label>
                                  </div>
                                  <div className="avatar-preview profile-user">
                                    <img
                                      src={previewUrlDefualt}
                                      // className="preview-image"

                                      style={{
                                        maxHeight: "100%",
                                        maxWidth: "100%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="row justify-content-start"
                              style={{ marginTop: "10px", display: "none" }}
                            >
                              <div className="accordion">
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="printerSettingsHeading"
                                  >
                                    <div
                                      className="accordion-button"
                                      style={{
                                        background: "#81bb42",
                                        width: "52px",
                                        height: "36px",
                                      }}
                                      aria-expanded="false"
                                      aria-controls="printerSettings"
                                    >
                                      Printer Settings
                                    </div>
                                  </h2>
                                  <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      <div className="row">
                                        <div
                                          className="col-md-4"
                                          style={{ display: "none" }}
                                        >
                                          {/* <FormGroup>
                                        <Label className="col-form-label ml-2 Label-my form-label">
                                          {"Which Printers"}
                                        </Label>
                                        <div style={{ display: "flex" }}>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadio"
                                              id="flexRadio1"
                                              value="1"
                                              checked={selectedRadio === "1"}
                                              onChange={handleRadioChange}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="flexRadio1"
                                            >
                                              Zebra Label
                                            </label>
                                          </div>

                                          <div
                                            className="form-check"
                                            style={{ marginLeft: "10px" }}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadio"
                                              id="flexRadio2"
                                              value="2"
                                              checked={selectedRadio === "2"}
                                              onChange={handleRadioChange}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="flexRadio2"
                                            >
                                              Brothers Label
                                            </label>
                                          </div>
                                        </div>
                                      </FormGroup> */}
                                        </div>

                                        <div
                                          className="col-md-4"
                                          style={{ display: "none" }}
                                        >
                                          <FormGroup>
                                            <Label className="col-form-label ml-2 Label-my form-label">
                                              {"Printer Name"}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  value={
                                                    settingCompanyData.printer_name
                                                  }
                                                  onChange={(e) => {
                                                    setSettingCompanyData({
                                                      ...settingCompanyData,
                                                      printer_name:
                                                        e.target.value,
                                                    });
                                                  }}
                                                  name={`printer_name`}
                                                  placeholder={t("printer_name")}
                                                />
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="col-md-4">
                                          <FormGroup>
                                            <Label className="col-form-label ml-2 Label-my form-label">
                                              {"Paper Size"}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  value={
                                                    settingCompanyData.paper_size
                                                  }
                                                  onChange={(e) => {
                                                    setSettingCompanyData({
                                                      ...settingCompanyData,
                                                      paper_size:
                                                        e.target.value,
                                                    });
                                                  }}
                                                  name={`paper_size`}
                                                  placeholder={t("paper_size")}
                                                />
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="col-md-4">
                                          <FormGroup>
                                            <Label className="col-form-label ml-2 Label-my form-label">
                                              {"Printer API"}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  value={
                                                    settingCompanyData.printer_api
                                                  }
                                                  onChange={(e) => {
                                                    setSettingCompanyData({
                                                      ...settingCompanyData,
                                                      printer_api:
                                                        e.target.value,
                                                    });
                                                  }}
                                                  name={`printer_api`}
                                                  placeholder={t("printer_api")}
                                                />
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>
                                        {/* <div
                                      className="col-md-4"
                                      style={{ marginTop: "40px" }}
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSettingPrintLabel}
                                      >
                                        Print Test Label{" "}
                                        <i className="bi bi-check2"></i>
                                      </button>
                                    </div> */}
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row border"
                            style={{
                              width: "99%",
                              marginTop: "15px",
                              marginBottom: "15px",
                              padding: "20px",
                              marginLeft: "7px",
                            }}
                          >
                            <div>
                              <h4
                                style={{
                                  backgroundColor: "#81bb42",
                                  color: "white",
                                  padding: "10px",
                                  margin: 0,
                                }}
                              >
                                Moloni Configuration
                              </h4>
                            </div>
                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("select_price")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      options={priceList}
                                      value={priceList.find(
                                        (option) =>
                                          option.value ===
                                          settingCompanyData.moloni_price_id,
                                      )}
                                      onChange={(selectedOption) =>
                                        setSettingCompanyData({
                                          ...settingCompanyData,
                                          moloni_price_id: selectedOption.value,
                                        })
                                      }
                                      placeholder={"Select Price"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Packaging"}
                                </Label>
                                <div
                                  className="col-xl-12"
                                  style={{
                                    marginTop: "-12px",
                                  }}
                                >
                                  <Button
                                    color="success"
                                    type={`button`}
                                    className={`btn-square`}
                                    onClick={handlePackingOpen}
                                  >
                                    <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                                    {"Packaging"}
                                  </Button>
                                  {selectedId != null && selectedId !== "0" && (
                                    <div className="col-md-12 mt-3">
                                      <button
                                        type="button"
                                        onClick={() => setDelPackingModal(true)}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#fff",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                        }}
                                        aria-label="Remove selected item"
                                      >
                                        ❌
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Other Parcel"}
                                </Label>
                                <div
                                  className="col-xl-12"
                                  style={{
                                    marginTop: "-12px",
                                  }}
                                >
                                  <Button
                                    color="success"
                                    type={`button`}
                                    className={`btn-square`}
                                    onClick={handleParcelOpen}
                                  >
                                    <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                                    {`Other Parcel`}
                                  </Button>
                                  {selectedParcelId != null &&
                                    selectedParcelId !== "0" && (
                                      <div className="col-md-12 mt-3">
                                        <button
                                          type="button"
                                          onClick={() => setDelOtherModal(true)}
                                          style={{
                                            border: "none",
                                            background: "transparent",
                                            color: "#fff",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                          }}
                                          aria-label="Remove selected parcel"
                                        >
                                          ❌
                                        </button>
                                      </div>
                                    )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Shipping"}
                                </Label>
                                <div
                                  className="col-xl-12"
                                  style={{
                                    marginTop: "-12px",
                                  }}
                                >
                                  <Button
                                    color="success"
                                    type={`button`}
                                    className={`btn-square`}
                                    onClick={handleShippingOpen}
                                  >
                                    <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                                    {`Shipping`}
                                  </Button>
                                  {selectedShippingId != null &&
                                    selectedShippingId !== "0" && (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          setDelShippingModal(true)
                                        }
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          cursor: "pointer",
                                          color: "red",
                                          fontSize: "16px",
                                        }}
                                        aria-label="Remove selected shipping"
                                      >
                                        ❌
                                      </button>
                                    )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {"Exemption Vat Other Parcel"}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div ">
                                    <Select
                                      options={exemptionList}
                                      value={
                                        exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.exemption_vat_products,
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setSettingCompanyData({
                                          ...settingCompanyData,
                                          exemption_vat_products: selectedOption
                                            ? selectedOption?.value
                                            : "",
                                        })
                                      }
                                      placeholder={
                                        "Select Exemption Vat Other Parcel"
                                      }
                                      isClearable
                                      isSearchable
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Exemption Vat Shipping"}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      options={exemptionList}
                                      value={
                                        exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.exemption_vat_shipping,
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setSettingCompanyData({
                                          ...settingCompanyData,
                                          exemption_vat_shipping: selectedOption
                                            ? selectedOption?.value
                                            : "",
                                        })
                                      }
                                      placeholder={
                                        "Select Exemption Vat Shipping"
                                      }
                                      isClearable
                                      isSearchable
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Exemption Vat Packaging"}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      options={exemptionList}
                                      value={
                                        exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.exemption_vat_packaging,
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setSettingCompanyData({
                                          ...settingCompanyData,
                                          exemption_vat_packaging:
                                            selectedOption
                                              ? selectedOption?.value
                                              : "",
                                        })
                                      }
                                      placeholder={
                                        "Select Exemption Vat Packaging"
                                      }
                                      isClearable
                                      isSearchable
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label">
                                  {"Exemption Reason"}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      options={exemptionList}
                                      value={
                                        exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            settingCompanyData.exemption_reason,
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setSettingCompanyData({
                                          ...settingCompanyData,
                                          exemption_reason: selectedOption
                                            ? selectedOption?.value
                                            : "",
                                        })
                                      }
                                      placeholder={"Select Exemption Reason"}
                                      isClearable
                                      isSearchable
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("is_all_sync")}{" "}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <div className="form-check">
                                      <input
                                        className="my-checkbox-1 form-check-input"
                                        type="checkbox"
                                        checked={
                                          settingCompanyData?.is_all_sync === 1
                                        }
                                        onChange={handleCheckboxSync}
                                      />
                                      <label className="form-check-label pl-6">
                                        {t("is_all_sync")}{" "}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("invoice_portal")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      options={invoiceList}
                                      value={invoiceList.find(
                                        (option) =>
                                          option.value ===
                                          settingCompanyData.invoice_platform_id,
                                      )}
                                      onChange={handleInvoiceChange}
                                      placeholder={"Select Invoice Portal"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            {settingCompanyData.invoice_platform_id === 1 && (
                              <div
                                className="col-md-3"
                                style={{ marginTop: "40px" }}
                              >
                                <button
                                  type="button"
                                  className={
                                    settingCompanyDetails?.is_platform_connect ===
                                    2
                                      ? "btn btn-danger"
                                      : "btn btn-primary"
                                  }
                                  onClick={handlePlatFormSubmit}
                                  disabled={loadingMoloni}
                                >
                                  {loadingMoloni ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : settingCompanyDetails?.is_platform_connect ===
                                    0 ? (
                                    t("connect")
                                  ) : settingCompanyDetails?.is_platform_connect ===
                                    1 ? (
                                    t("connected")
                                  ) : settingCompanyDetails?.is_platform_connect ===
                                    2 ? (
                                    t("disconnect")
                                  ) : (
                                    ""
                                  )}
                                </button>
                              </div>
                            )}

                            <div className="col-md-3"></div>
                            <div className="col-md-3"></div>
                            {settingCompanyData.invoice_platform_id === 1 && (
                              <div className="col-md-12">
                                <table className="rounded-table table table-striped table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th style={{ width: "10%" }}>
                                        {t("created_at")}
                                      </th>
                                      <th style={{ width: "10%" }}>
                                        {t("expires_at")}
                                      </th>
                                      <th style={{ width: "10%" }}>
                                        {t("refresh_expires_at")}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>
                                        {settingCompanyDetails?.tokenData
                                          ?.created_at
                                          ? moment(
                                              settingCompanyDetails.tokenData
                                                .created_at,
                                            ).format("DD MMM YYYY, hh:mm A")
                                          : "-"}
                                      </td>
                                      <td>
                                        {settingCompanyDetails?.tokenData
                                          ?.expires_at
                                          ? moment(
                                              settingCompanyDetails.tokenData
                                                .expires_at,
                                            ).format("DD MMM YYYY, hh:mm A")
                                          : "-"}
                                      </td>
                                      <td>
                                        {settingCompanyDetails?.tokenData
                                          ?.refresh_expires_at
                                          ? moment(
                                              settingCompanyDetails.tokenData
                                                .refresh_expires_at,
                                            ).format("DD MMM YYYY, hh:mm A")
                                          : "-"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>

                          <div className="row">
                            <div className="vehicleparts-table-inner vehicleThBg tableScroll table-scroll-modal">
                              <table className="rounded-table table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th style={{ width: "10%" }}>Attribute</th>
                                    <th style={{ width: "10%" }}>Is View</th>
                                    <th style={{ width: "10%" }}>Is Edit</th>

                                    <th style={{ width: "10%" }}>
                                      {t("role")}
                                    </th>

                                    <th style={{ width: "0%" }}>
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {settingCompanyDataList?.map(
                                    (settingCompanyData, index) => {
                                      return (
                                        <>
                                          <tr key={index}>
                                            <td>
                                              <FormGroup
                                                style={{ width: "475px" }}
                                              >
                                                <Select
                                                  options={attributeList}
                                                  value={attributeList.filter(
                                                    (option) =>
                                                      (
                                                        settingCompanyData.attribute_id ||
                                                        ""
                                                      )
                                                        .split(",")
                                                        .includes(
                                                          String(option.value),
                                                        ),
                                                  )}
                                                  onChange={(selectedOptions) =>
                                                    handleAttributeChange(
                                                      selectedOptions,
                                                      index,
                                                    )
                                                  }
                                                  isSearchable
                                                  isClearable
                                                  isMulti
                                                  placeholder={t("select_attribute")}
                                                />
                                              </FormGroup>
                                            </td>

                                            <td>
                                              <FormGroup>
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  checked={
                                                    !!settingCompanyData.is_view
                                                  }
                                                  onChange={() =>
                                                    handleCheckboxAttributeChange(
                                                      index,
                                                      "is_view",
                                                    )
                                                  }
                                                  style={{
                                                    marginLeft: "50px",
                                                    width: "21px",
                                                    height: "21px",
                                                    marginTop: "-8px",
                                                  }}
                                                />
                                              </FormGroup>
                                            </td>

                                            <td>
                                              <FormGroup>
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  checked={
                                                    !!settingCompanyData.is_edit
                                                  }
                                                  onChange={() =>
                                                    handleCheckboxAttributeChange(
                                                      index,
                                                      "is_edit",
                                                    )
                                                  }
                                                  style={{
                                                    marginLeft: "50px",
                                                    width: "21px",
                                                    height: "21px",
                                                    marginTop: "-8px",
                                                  }}
                                                />
                                              </FormGroup>
                                            </td>

                                            <td>
                                              <FormGroup>
                                                <Select
                                                  options={roleList}
                                                  value={roleList.find(
                                                    (option) =>
                                                      option.value ===
                                                      settingCompanyData.role_id,
                                                  )}
                                                  onChange={(selectedOption) =>
                                                    handleRoleChange(
                                                      selectedOption,
                                                      index,
                                                    )
                                                  }
                                                  placeholder={t("select_role")}
                                                />
                                              </FormGroup>
                                            </td>

                                            <td>
                                              <div className="d-flex">
                                                {/* {index ===
                                                  settingCompanyDataList.length -
                                                    1 &&
                                                  !settingCompanyDataList.some(
                                                    (row) => row.attribute_id
                                                  ) && ( */}
                                                <button
                                                  type="button"
                                                  className="btn btn-success btn-sm mr-2"
                                                  onClick={handleAddRow}
                                                >
                                                  +
                                                </button>

                                                {settingCompanyDataList?.length >
                                                  1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-success btn-sm mr-2"
                                                    onClick={() =>
                                                      handleRemoveRow(index)
                                                    }
                                                  >
                                                    -
                                                  </button>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    },
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Select Part Inventory Columns"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    options={partInventoryList}
                                    value={(
                                      settingCompanyData.part_display_column_ids ||
                                      ""
                                    )
                                      .split(",")
                                      .map((id) =>
                                        partInventoryList.find(
                                          (option) =>
                                            String(option.value) === id,
                                        ),
                                      )
                                      .filter(Boolean)}
                                    onChange={handleSelectPartInventoryChange}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti
                                    placeholder={
                                      "Select Part Inventory Columns"
                                    }
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {"Select Vehicle Columns"}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    options={vehicleList}
                                    value={(
                                      settingCompanyData.vehicle_display_column_ids ||
                                      ""
                                    )
                                      .split(",")
                                      .map((id) =>
                                        vehicleList.find(
                                          (option) =>
                                            String(option.value) === id,
                                        ),
                                      )
                                      .filter(Boolean)}
                                    onChange={handleSelectVehicleDisplayChange}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti
                                    placeholder={"Select Vehicle Columns"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="row">
                      <div className="col"></div>
                      <div className="col">
                        <div
                          className="d-flex justify-content-end"
                          style={{ padding: "10px" }}
                        >
                          <button type="submit" className="btn btn-primary">{t("submit")}<i className="bi bi-check2"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer"></div>
                  </Form>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={showModal}>
          <ModalHeader>Header Image</ModalHeader>
          <ModalBody>
            <img
              src={previewUrl}
              alt="Preview"
              style={{ width: "100%", height: "auto" }}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={handleClose}>{t("close")}</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={showModalAbout}>
          <ModalHeader>About Image</ModalHeader>
          <ModalBody>
            <img
              src={previewUrlAbout}
              alt="Preview"
              style={{ width: "100%", height: "auto" }}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={handleCloseAbout}>{t("close")}</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={companystatus}>
          <ModalHeader>Change Plan</ModalHeader>
          <Form method={`post`} onSubmit={handleChangePlanSubmit}>
            <ModalBody>
              <div className="row">
                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label Label-my ml-2">
                      {"Plan"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <Select
                          options={SubscriptionList}
                          value={SubscriptionList.find(
                            (option) =>
                              option.value ===
                              Number(CompanyPlanData.subscription_id),
                          )}
                          onChange={handleSelectPlanChange}
                          isSearchable={true}
                          isClearable={true}
                          placeholder={"Select Plan"}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>

                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {"Expiry Date"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <input
                          type="date"
                          id="subscription_expiry"
                          className="form-control"
                          value={formatDate(
                            CompanyPlanData.subscription_expiry,
                          )}
                          onChange={(e) => {
                            SetCompanyPlanData({
                              ...CompanyPlanData,
                              subscription_expiry: e.target.value, // Directly set the YYYY-MM-DD format
                            });
                          }}
                          placeholder={t("expiry_date")}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>

                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {"is Subscribed"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={CompanyPlanData?.is_subscribed === 1}
                            onChange={handleCheckboxChangeIsSubscribe}
                          />
                          <label className="form-check-label">
                            is Subscribed{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleCloseCompany}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("close")}<i className="bi bi-x-lg"></i>
              </button>
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >{t("submit")}<i className="bi bi-check2"></i>
              </button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={packagingModel}>
          <ModalHeader>Packaging Value</ModalHeader>
          <Form method={`post`}>
            <ModalBody>
              <div className="row">
                <div style={{ maxHeight: "300px", overflow: "auto" }}>
                  <div
                    className="card-title m-0 float-left"
                    style={{ width: "50%" }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      value={packingSerach}
                      onChange={(e) => setPackingSerach(e.target.value)}
                      placeholder={t("search_product")}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th></th>
                        <th>{t("name")}</th>
                        <th>{t("summary")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {packingList?.length > 0 &&
                        packingList?.map((item, index) => {
                          return (
                            <tr key={item.product_id ?? index}>
                              <td>
                                <input
                                  type="radio"
                                  name="packingSelect"
                                  value={item.product_id}
                                  checked={selectedId?.id === item.product_id}
                                  onChange={() =>
                                    setSelectedId({
                                      id: item.product_id,
                                      name: item?.name,
                                    })
                                  }
                                />
                              </td>

                              <td>{item.name || "-"}</td>
                              <td>{item.summary}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handlePackingClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("close")}<i className="bi bi-x-lg"></i>
              </button>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handlePackingClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("save")}<i className="bi bi-check2"></i>
              </button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={otherParcelModel}>
          <ModalHeader>Parcel Value</ModalHeader>
          <Form method={`post`}>
            <ModalBody>
              <div className="row">
                <div style={{ maxHeight: "300px", overflow: "auto" }}>
                  <div
                    className="card-title m-0 float-left"
                    style={{ width: "50%" }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      value={parcelSerach}
                      onChange={(e) => setParcelSerach(e.target.value)}
                      placeholder={t("search_product")}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th></th>
                        <th>{t("name")}</th>
                        <th>{t("summary")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {parcelList?.length > 0 &&
                        parcelList?.map((item, index) => {
                          return (
                            <tr key={item.product_id ?? index}>
                              <td>
                                <input
                                  type="radio"
                                  name="packingSelect"
                                  value={item.product_id}
                                  checked={
                                    selectedParcelId?.id === item.product_id
                                  }
                                  onChange={() =>
                                    setSelectedParcelId({
                                      id: item.product_id,
                                      name: item?.name,
                                    })
                                  }
                                />
                              </td>

                              <td>{item.name || "-"}</td>
                              <td>{item.summary}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleParcelClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("close")}<i className="bi bi-x-lg"></i>
              </button>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleParcelClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("save")}<i className="bi bi-check2"></i>
              </button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={shippingModel}>
          <ModalHeader>Shipping Value</ModalHeader>
          <Form method={`post`}>
            <ModalBody>
              <div className="row">
                <div style={{ maxHeight: "300px", overflow: "auto" }}>
                  <div
                    className="card-title m-0 float-left"
                    style={{ width: "50%" }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      value={shippingSerach}
                      onChange={(e) => setShippingSerach(e.target.value)}
                      placeholder={t("search_product")}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th></th>
                        <th>{t("name")}</th>
                        <th>{t("summary")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {shippingList?.length > 0 &&
                        shippingList?.map((item, index) => {
                          return (
                            <tr key={item.product_id ?? index}>
                              <td>
                                <input
                                  type="radio"
                                  name="packingSelect"
                                  value={item.product_id}
                                  checked={
                                    selectedShippingId?.id === item.product_id
                                  }
                                  onChange={() =>
                                    setSelectedShippingId({
                                      id: item.product_id,
                                      name: item?.name,
                                    })
                                  }
                                />
                              </td>

                              <td>{item.name || "-"}</td>
                              <td>{item.summary}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleShippingClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("close")}<i className="bi bi-x-lg"></i>
              </button>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleShippingClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("save")}<i className="bi bi-check2"></i>
              </button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={delPackingModal}>
          <ModalHeader>{t("Delete Packaging")}</ModalHeader>
          <ModalBody>
            <p className={`mb-0`}>{t("Are you sure yow want delete this?")}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onDeleteModalPackingClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={() => {
                setSelectedId(null);

                setDelPackingModal(false);
              }}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={delOtherModal}>
          <ModalHeader>{t("Delete Other Parcel")}</ModalHeader>
          <ModalBody>
            <p className={`mb-0`}>{t("Are you sure yow want delete this?")}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onDeleteModalOtherClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={() => {
                setSelectedParcelId(null);

                setDelOtherModal(false);
              }}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={delShippingModal}>
          <ModalHeader>{t("Delete Other Parcel")}</ModalHeader>
          <ModalBody>
            <p className={`mb-0`}>{t("Are you sure yow want delete this?")}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onDeleteModalShipplingClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={() => {
                setSelectedShippingId(null);

                setDelShippingModal(false);
              }}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          </ModalFooter>
        </Modal>
      </section>
    </div>
  );
};

export default Settings;
